import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Cursor = ({
  size,
  type,
  theme,
  className,
  dataTestId = "cursor-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.471 1.529a.666.666 0 0 1 .169.66L11.306 13.52a.667.667 0 0 1-1.211.155l-1.56-2.6-3.397 3.395a.667.667 0 0 1-.943 0L1.53 11.805a.667.667 0 0 1 0-.943l3.396-3.396-2.601-1.561a.667.667 0 0 1 .155-1.211L13.812 1.36a.667.667 0 0 1 .66.169ZM4.313 5.544l2.03 1.218a.667.667 0 0 1 .128 1.043l-3.528 3.528 1.724 1.724L8.195 9.53a.667.667 0 0 1 1.043.128l1.218 2.03 2.56-8.703-8.703 2.56Z"
    />
  </SVGIcon>
);
